import { Typography } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import styles from './index.less';

const ResultLink = ({lead}: {lead: LeadModel, isTable?: boolean}) => {
  const url = lead?.customer?.links?.view;
  if (!url) return <span>-</span>;

  return (
    <Typography.Text className={styles.resultLink} copyable={{ text: url }}>
      <a target={'_blank'} title={url} className={'color-secondary'} href={url}>
        {url}
      </a>
    </Typography.Text>
  );
}

export default ResultLink
